module.exports = __webpack_public_path__ + "static/media/LogicWedge5_3_3.aae4f0c5.png";